import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import BookADemoButton from '../../ui/BookADemoButton'
// views
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
import {
  descriptionAnimation,
  titleAnimation,
  subtitleAnimation,
} from '../../../constants/animation'
// assets
import Glow from '../../glows'
import StaffingImg from '../../../assets/imgs/staffing/staffing.png'

const StaffingComponent = () => {
  return (
    <section className='overview-section staffing-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer className='staffing-grid-container'>
          <div>
            <motion.p
              className='overview-title staffing-overview-title'
              variants={titleAnimation}
            >
              Reduce Time-to-Fill and Maximize Candidate Pools
            </motion.p>
            <motion.p
              className='staffing-subtitle'
              variants={subtitleAnimation}
            >
              Speed, rediscovery, and intelligence that boost placements and
              revenue.
            </motion.p>
            <motion.p className='description' variants={descriptionAnimation}>
              Pod unlocks the hidden value in your ATS by surfacing past
              candidates for new roles instantly. AI-driven matching ranks
              best-fit talent, while heatmaps highlight availability by location
              to accelerate placements. By embedding Pod dashboards into client
              workflows, staffing firms deepen relationships, reduce churn, and
              open doors to higher-value services in retention and mobility.
            </motion.p>
            <div className='staffing-button-container'>
              <BookADemoButton />
            </div>
          </div>
          <div className='img-container'>
            <img
              className='staffing-image'
              src={StaffingImg}
              alt='Staffing Presentation'
            />
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default StaffingComponent
